import React from 'react';
import { Box, Button, createStyles, makeStyles, MenuItem, TextField, Typography } from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
const HTTP_PREFIXES = ['http', 'https'];
// Стили совпадают с формой добавления системы.
const useStyles = makeStyles(() => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '800px',
        padding: '72px',
    },
    header: {
        fontWeight: 600,
        marginBottom: '32px',
    },
    subheader: {
        fontWeight: 600,
        marginTop: '16px',
        marginBottom: '16px',
    },
    input: {
        width: '370px',
        marginBottom: '16px',
    },
    submit: {
        marginTop: '16px',
    },
}));
export const FormAdd = ({ onSubmit, isSubmitting, pluginInstanceError }) => {
    const styles = useStyles();
    const { register, control, handleSubmit } = useForm({
        defaultValues: {
            name: '',
            httpHeader: '',
            host: '',
            port: '',
            customHeadHttpPrefix: '',
            customHeadHost: '',
            customHeadPort: '',
        },
    });
    // Ошибки валидации приходят с бэкенда, имя поля сравниваем без учёта регистра.
    const getErrorText = (name) => pluginInstanceError
        ?.find((error) => String(error?.fieldName).toLowerCase() === name.toLowerCase())
        ?.fieldErrors?.join(' ');
    // Незаполненные поля не отправляем, как и раньше: пустая строка в числовом поле
    // (customHeadPort) не разбирается бэкендом, а отсутствие поля - допустимо.
    const handleSubmitForm = (data) => {
        const filled = Object.fromEntries(Object.entries(data).filter(([, value]) => value !== ''));
        onSubmit(filled);
    };
    const renderTextField = (name, label, required = false) => (React.createElement(TextField, { className: styles.input, variant: "outlined", label: label, required: required, name: name, inputRef: register(), error: Boolean(getErrorText(name)), helperText: getErrorText(name) }));
    const renderPrefixField = (name, label, required = false) => (React.createElement(Controller, { name: name, control: control, render: ({ value, onChange, onBlur }) => (React.createElement(TextField, { className: styles.input, variant: "outlined", label: label, required: required, select: true, value: value ?? '', onChange: ({ target }) => onChange(target.value), onBlur: onBlur, error: Boolean(getErrorText(name)), helperText: getErrorText(name) }, HTTP_PREFIXES.map((prefix) => (React.createElement(MenuItem, { key: prefix, value: prefix }, prefix))))) }));
    return (React.createElement("form", { className: styles.root, noValidate: true, autoComplete: "off", onSubmit: handleSubmit(handleSubmitForm) },
        React.createElement(Typography, { className: styles.header, variant: "h4", component: "h2" }, "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0430\u0433\u0435\u043D\u0442\u0430"),
        renderTextField('name', 'Название агента', true),
        renderPrefixField('httpHeader', 'Заголовок HTTP', true),
        renderTextField('host', 'Адрес', true),
        renderTextField('port', 'Порт', true),
        React.createElement(Typography, { className: styles.subheader, variant: "h6", component: "h3" }, "Head"),
        renderPrefixField('customHeadHttpPrefix', 'Протокол'),
        renderTextField('customHeadHost', 'Хост Head'),
        renderTextField('customHeadPort', 'Custom Head Port'),
        React.createElement(Box, { className: styles.submit, display: "flex", alignItems: "center" },
            React.createElement(Button, { type: "submit", variant: "contained", color: "primary", disabled: isSubmitting }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"))));
};
